import styled from "@emotion/styled";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 100%;
  padding: 10px 0 0 0;
  overflow-y: hidden;
  overflow-x: hidden;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 18px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  width: 100%;
  padding-right: 3%;
  min-height: 0;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: #cfe5ff;
  color: #2563eb;
  margin-bottom: 12px;

  i {
    font-size: 20px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: #101828;
  font-size: 18px;
  font-weight: 600;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding-bottom: 12px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FloatingField = styled.div`
  position: relative;
  margin-top: 6px;
`;

export const FieldLabel = styled.label`
  position: absolute;
  top: -8px;
  left: 8px;
  z-index: 1;
  background: #ffffff;
  padding: 0 4px;
  color: #999999;
  font-size: 12px;
  font-weight: 400;
`;

export const TopFieldLabel = styled.label`
  color: #98a2b3;
  font-size: 12px;
  font-weight: 500;
`;

export const SharedInputCss = `
  width: 100%;
  min-height: 38px;
  border-radius: 4px;
`;

export const FormInput = styled(InputText)`
  ${SharedInputCss}
`;

export const FormDropdown = styled(Dropdown)`
  ${SharedInputCss}
  display: flex;
  align-items: center;

  .p-dropdown-label {
    display: flex;
    align-items: center;
    min-height: 38px;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .p-placeholder {
    color: #98a2b3;
  }
`;

export const ContactOptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ContactOptionName = styled.span`
  color: #101828;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
`;

export const ContactOptionPhone = styled.span`
  color: #98a2b3;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
`;

export const FormTextarea = styled(InputTextarea)`
  width: 100%;
  min-height: 98px;
  border-radius: 4px;
  resize: none;
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2563eb;
  font-size: 14px;
  cursor: pointer;
`;

export const CalendarRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const CalendarFieldWrapper = styled.div`
  .p-calendar {
    width: 100%;
  }

  .p-calendar .p-inputtext {
    color: #344054;
  }

  .p-calendar .p-inputtext::placeholder {
    color: #98a2b3;
  }

  .p-inputtext {
    border-radius: 0;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  padding: 10px 3% 8px 0;
  width: 100%;
  background: #ffffff;
`;

export const FooterButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #14223b;
  border-radius: 6px;
  border: 1px solid #ced4da;
  padding: 10px 12px;
  width: 50%;
  font-weight: 600;
  gap: 10px;

  &:enabled:hover {
    background: #ffffff;
    color: #14223b;
    border-color: #ced4da;
    box-shadow: none;
  }
`;

export const PrimaryFooterButton = styled(FooterButton)<{ color: string }>`
  background: ${({ color }) => color};
  border-color: ${({ color }) => color};
  color: #ffffff;

  &:enabled:hover {
    background: ${({ color }) => color};
    border-color: ${({ color }) => color};
    color: #ffffff;
  }
`;

export const SecondaryFooterButton = styled(FooterButton)`
  &:enabled:hover {
    background: #ffffff;
    color: #14223b;
    border-color: #ced4da;
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
